import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 93527 97588"
    {...props}
  >
    <defs>
      <style>
        {
          // ".str1{stroke:#2b2a29;stroke-width:1077.74}.str0{stroke:#000;stroke-width:1414.35;stroke-linecap:round;stroke-linejoin:round}.fil0{fill:none}.fil1{fill:#1c1b17}"
        }
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_2528318538944">
        <path
          d="M4444 2946h84812M4438 2573c0 1029-836 1865-1865 1865-1031 0-1866-836-1866-1865 0-1031 835-1866 1866-1866 1029 0 1865 835 1865 1866zM61795 96880l687-85373c-2482 1286-3222-1117-5353-261-2183 875-2334 1082-4668 1082-2329 0-2329-1082-4660-1082-2324 0-2324 1082-4648 1082-2328 0-2328-1082-4656-1082-2325 0-2325 1082-4649 1082-2322 0-2322-1082-4644-1082-2326 0-2326 1082-4651 1082-2318 0-2318-1082-4636-1082-2324 0-2591 2664-5653 988-1788-979-3195-1269-4191-1063-615 127-1038 727-1038 1390v83761M23242 12098l1-8996M34729 11661V3095M46217 11407l-30-8305M58312 11074V3102M12257 11362l-20-8260"
          className="fill-none stroke1"
          style={{
            strokeWidth: 1414.35,
          }}
        />
        <path
          d="M9035 93575c2455-987 2397 557 4795 557 2394 0 2394-1116 4790-1116 2397 0 2397 1116 4793 1116 2398 0 2398-1116 4795-1116 2393 0 2393 1116 4785 1116 2397 0 2397-1116 4793-1116 2399 0 2399 1116 4797 1116 2399 0 2399-1116 4798-1116 2400 0 2400 1116 4800 1116 2403 0 2403-1116 4808-1116 2403 0 2403 1116 4807 1116M35758 94917V53969M22344 95765V72290M48750 94917V64749M22344 62775V40231M35758 44406V29795M48750 56409V43466"
          className="fill-none stroke1"
          style={{
            strokeWidth: 1414.35,
          }}
        />
        <circle
          cx={2572}
          cy={2573}
          r={1869}
          className="fill stroke1"
          style={{
            strokeWidth: 1077.74,
          }}
        />
        <circle
          cx={91120}
          cy={2573}
          r={1869}
          className="fill stroke1"
          style={{
            strokeWidth: 1077.74,
          }}
        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
